import { useMemo } from "react";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { formatSpecifications } from "../../../shared/lib/format/specification/formatSpecifications.js";
import "../../../shared/lib/logger/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { schemes, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const items = useMemo(
    () => vehicleItem ? formatSpecifications(vehicleItem, schemes).map((item2) => ({
      id: item2.id,
      icon: item2.icon,
      text: item2.value
    })) : [],
    [vehicleItem, schemes]
  );
  return {
    ...props,
    items,
    isLoading
  };
};
export {
  useContainer
};
